/* tslint:disable */
/* eslint-disable */
/**
 * Bookingkit Api v4
 * Specification of Bookingkit Api v4
 *
 * The version of the OpenAPI document: 0.19.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PaymentProviderActivation
 */
export interface PaymentProviderActivation {
    /**
     * 
     * @type {string}
     * @memberof PaymentProviderActivation
     */
    'type': PaymentProviderActivationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentProviderActivation
     */
    'date'?: string;
}

export const PaymentProviderActivationTypeEnum = {
    Asap: 'ASAP',
    DateBased: 'DATE_BASED'
} as const;

export type PaymentProviderActivationTypeEnum = typeof PaymentProviderActivationTypeEnum[keyof typeof PaymentProviderActivationTypeEnum];


